import { ClientDashboardHomeJobOrderDto } from '@hoqus/connectis-client-dashboard-types';
import { mapDtoToJobOrderType } from 'types/JobOrder/mapper.ts';
import { DashboardHomeJobOrderType } from './DashboardHomeJobOrderType.ts';

export const mapDtoToDashboardHomeJobOrder = (
  dto: ClientDashboardHomeJobOrderDto,
): DashboardHomeJobOrderType => ({
  ...mapDtoToJobOrderType(dto),
  expertBlindsCount: dto.expertBlindsCount,
  progressStage: dto.progressStage,
});
